// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3oupD","colMaxWidth":"Table_colMaxWidth__7GtqX"};